import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import HaloSecurityMappingForm from "./HaloSecurityMappingForm";
import HaloSecurityCredentialsForm from "./HaloSecurityCredentialsForm";
export default function HaloSecurityConfigListing(props) {
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={HaloSecurityMappingForm}
      CredentialsForm={HaloSecurityCredentialsForm}
      componentName="Target"
      componentKey={"targetName"}
    />
  );
}
